

export const defaultDistrict = {
  logo: null,
  name: '',
  color: '#538B9B'
}
